import React, { useState } from "react";
import {
  FaVideo,
  FaUserGraduate,
  FaHome,
  FaClipboardList,
  FaGraduationCap,
  FaChalkboardTeacher,
  FaChartBar,
  FaFileAlt,
} from "react-icons/fa";
import {
  DashboardContainer,
  SpaceBackground,
  WelcomeSection,
  WelcomeTitle,
  WelcomeText,
  DashboardGrid,
  GridColumn,
  DashboardCard,
  NotificationBar,
  WorkshopsList,
  WorkshopItem,
  WorkshopDate,
  WorkshopTitle,
  WorkshopLocation,
  RegisteredBadge,
  ViewAllButton,
  CounselorsList,
  CounselorItem,
  CounselorImage,
  CounselorInfo,
  CounselorName,
  CounselorSpecialty,
  CounselorAvailability,
  ScheduleButton,
  AppointmentRequestForm,
  FormInputGroup,
  FormButtons,
  SectionDivider,
  AppointmentsList,
  AppointmentItem,
  AppointmentDate,
  AppointmentReason,
  AppointmentStatus,
  VideoContainer,
  VideoControls,
  VideoButton,
  VideoStatus,
  SuggestedCompaniesSection,
  CompanyCard,
  CompanyLogo,
  CompanyInfo,
  CompanyName,
  CompanyDescription,
  CompanyTags,
  CompanyTag,
  ApplyButton,
} from "../../../styles/components/ProStudentDashboard/styles";
import styled, { keyframes } from "styled-components";
import { Button, PageTitle } from "../../../styles/components";
import { PageHeader } from "../../../styles/components";
import ProfileViews from "../../../components/proStudent/ProfileViews";

// Import the components
import AssessmentCenter from "../../../pages/AssessmentCenter/AssessmentCenter";
import StudentProfile from "../../../components/proStudent/StudentProfile";
import MajorsList from "../../../components/proStudent/MajorsList/MajorsList";
import WorkshopHub from "../../../pages/WorkshopHub/WorkshopHub";
import Internships from "../../../pages/Internships/Internships";
import ReportManagement from "../../../components/student/ReportManagement/ReportManagement";
import ApplicationsList from "../../../components/student/ApplicationsList/ApplicationsList";
import VideoCallSystemDemo from "../../../components/proStudent/VideoCallSystem/VideoCallSystemDemo";
import InternshipGuidelinesVideo from "../../../components/student/InternshipGuidelines/InternshipGuidelinesVideo";

// Import mock data
import companiesData from "../../../data/mock/companies";

// Advanced moving neon glow animations
const neonPulse = keyframes`
  0% { opacity: 0.3; }
  50% { opacity: 0.8; }
  100% { opacity: 0.3; }
`;

// Animation for the moving light border
const borderGlow = keyframes`
  0% { box-shadow: 0 0 10px rgba(99, 102, 241, 0.3), inset 0 0 5px rgba(99, 102, 241, 0.1); }
  50% { box-shadow: 0 0 15px rgba(99, 102, 241, 0.5), inset 0 0 8px rgba(99, 102, 241, 0.2); }
  100% { box-shadow: 0 0 10px rgba(99, 102, 241, 0.3), inset 0 0 5px rgba(99, 102, 241, 0.1); }
`;

// Orbital neon movement for the glow effect
const orbitGlow = keyframes`
  0% { transform: translateX(-100%) translateY(-100%) scale(0.8); }
  25% { transform: translateX(200%) translateY(-50%) scale(1); }
  50% { transform: translateX(200%) translateY(200%) scale(1.2); }
  75% { transform: translateX(-50%) translateY(200%) scale(1); }
  100% { transform: translateX(-100%) translateY(-100%) scale(0.8); }
`;

// Subtle perimeter scan effect
const scanEffect = keyframes`
  0% { background-position: 0% 0%; }
  100% { background-position: 200% 0%; }
`;

// Navigation Header Components
// Removed unused DashboardHeader

const NavContainer = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 2.5rem;
  background: rgba(15, 23, 42, 0.65);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 14px;
  padding: 0.85rem 1rem;
  position: relative;
  overflow: hidden;
  z-index: 1;

  /* Futuristic glassy border effect */
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  animation: ${borderGlow} 4s infinite ease-in-out;

  /* Space background gradients */
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
        circle at 15% 50%,
        rgba(99, 102, 241, 0.12) 0%,
        transparent 45%
      ),
      radial-gradient(
        circle at 85% 30%,
        rgba(124, 58, 237, 0.08) 0%,
        transparent 45%
      );
    z-index: -1;
  }

  /* Dynamic neon glow orb that moves around container edges */
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;

    /* Star-like dots in background */
    background-image: radial-gradient(
        1px 1px at 20% 30%,
        rgba(255, 255, 255, 0.8) 1px,
        transparent 0
      ),
      radial-gradient(
        1px 1px at 40% 70%,
        rgba(255, 255, 255, 0.7) 1px,
        transparent 0
      ),
      radial-gradient(
        1px 1px at 60% 40%,
        rgba(255, 255, 255, 0.8) 1px,
        transparent 0
      ),
      radial-gradient(
        1px 1px at 80% 60%,
        rgba(255, 255, 255, 0.7) 1px,
        transparent 0
      );
    opacity: 0.4;
  }

  /* Moving perimeter glow effect */
  &:before {
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(99, 102, 241, 0.1) 25%,
      rgba(124, 58, 237, 0.2) 50%,
      rgba(99, 102, 241, 0.1) 75%,
      transparent 100%
    );
    background-size: 200% 100%;
    animation: ${scanEffect} 8s infinite linear;
  }

  /* Orbital neon glow */
  .neon-orb {
    position: absolute;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background: radial-gradient(
      circle at center,
      rgba(99, 102, 241, 0.4) 0%,
      rgba(124, 58, 237, 0.2) 40%,
      transparent 70%
    );
    filter: blur(20px);
    animation: ${orbitGlow} 15s infinite ease-in-out;
    z-index: -1;
    opacity: 0.6;
  }

  /* Pulsing neon spots */
  .neon-spot-1,
  .neon-spot-2,
  .neon-spot-3 {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    z-index: -1;
    filter: blur(10px);
  }

  .neon-spot-1 {
    background: rgba(99, 102, 241, 0.7);
    top: 10px;
    right: 30%;
    animation: ${neonPulse} 3s infinite ease-in-out;
  }

  .neon-spot-2 {
    background: rgba(124, 58, 237, 0.7);
    bottom: 15px;
    left: 25%;
    animation: ${neonPulse} 4s 0.5s infinite ease-in-out;
  }

  .neon-spot-3 {
    background: rgba(79, 70, 229, 0.7);
    top: 50%;
    left: 15px;
    animation: ${neonPulse} 5s 1s infinite ease-in-out;
  }

  @media (max-width: 768px) {
    padding: 1rem;
    gap: 1rem;
  }
`;

const NavLogo = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-shadow: 0 0 10px rgba(99, 102, 241, 0.5);

  svg {
    color: rgba(99, 102, 241, 0.9);
    filter: drop-shadow(0 0 5px rgba(99, 102, 241, 0.7));
    font-size: 1.8rem;
  }

  &:hover {
    color: white;
    text-shadow: 0 0 15px rgba(99, 102, 241, 0.7);

    svg {
      filter: drop-shadow(0 0 8px rgba(99, 102, 241, 0.9));
    }
  }
`;

const NavButton = styled(Button)`
  flex: 1;
  min-width: 120px;
  background: ${(props) =>
    props.active ? "rgba(79, 70, 229, 0.75)" : "rgba(15, 23, 42, 0.4)"};
  color: ${(props) => (props.active ? "white" : "rgba(255, 255, 255, 0.8)")};
  border: ${(props) =>
    props.active
      ? "1px solid rgba(99, 102, 241, 0.5)"
      : "1px solid rgba(148, 163, 184, 0.2)"};
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  /* Improved hover effect with neon glow */
  &:hover {
    background: ${(props) =>
      props.active ? "rgba(79, 70, 229, 0.85)" : "rgba(99, 102, 241, 0.25)"};
    transform: translateY(-3px);
    box-shadow: ${(props) =>
      props.active
        ? "0 8px 25px -5px rgba(79, 70, 229, 0.5), 0 0 15px rgba(99, 102, 241, 0.6)"
        : "0 7px 20px -5px rgba(31, 38, 135, 0.3), 0 0 12px rgba(99, 102, 241, 0.4)"};
    color: white;
    text-shadow: 0 0 8px rgba(255, 255, 255, 0.8);

    svg {
      transform: scale(1.1);
      filter: drop-shadow(0 0 5px rgba(99, 102, 241, 0.8));
    }
  }

  /* Active state enhanced neon glow effect */
  ${(props) =>
    props.active &&
    `
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 18px rgba(99, 102, 241, 0.6), inset 0 0 8px rgba(99, 102, 241, 0.4);
  `}

  /* Futuristic gradient overlay */
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      ${(props) =>
        props.active
          ? "rgba(129, 140, 248, 0.4) 0%, rgba(79, 70, 229, 0.4) 100%"
          : "rgba(255, 255, 255, 0.05) 0%, rgba(15, 23, 42, 0.05) 100%"}
    );
    z-index: -1;
  }

  /* Enhanced shiny animation on hover */
  &:after {
    content: "";
    position: absolute;
    width: 150%;
    height: 200%;
    top: -200%;
    left: -50%;
    background: linear-gradient(
      45deg,
      transparent 0%,
      rgba(255, 255, 255, 0.1) 45%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0.1) 55%,
      transparent 100%
    );
    transform: rotate(25deg);
    transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
    z-index: 1;
  }

  &:hover:after {
    top: 200%;
    left: 100%;
  }

  svg {
    font-size: 1.2rem;
    margin-right: 0.5rem;
    vertical-align: middle;
    position: relative;
    top: -1px;
    transition: all 0.3s ease;

    /* Enhanced icon glow effect on active state */
    ${(props) =>
      props.active &&
      `
      filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.7));
    `}
  }
`;

const NavRow = styled.div`
  display: flex;
  gap: 1.25rem;
  width: 100%;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.75rem;
  }
`;

// StatusBadge component for workshop status labels
const StatusBadge = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  z-index: 1;
  background: ${({ status }) => {
    switch (status) {
      case "live":
        return "linear-gradient(135deg, rgba(239, 68, 68, 0.9), rgba(220, 38, 38, 0.9))";
      case "upcoming":
        return "linear-gradient(135deg, rgba(245, 158, 11, 0.9), rgba(217, 119, 6, 0.9))";
      case "pre-recorded":
        return "linear-gradient(135deg, rgba(16, 185, 129, 0.9), rgba(5, 150, 105, 0.9))";
      case "completed":
        return "linear-gradient(135deg, rgba(107, 114, 128, 0.9), rgba(75, 85, 99, 0.9))";
      default:
        return "linear-gradient(135deg, rgba(99, 102, 241, 0.9), rgba(79, 70, 229, 0.9))";
    }
  }};
  backdrop-filter: blur(8px);
  color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
`;

const ProStudentDashboard = () => {
  const [activeView, setActiveView] = useState("dashboard");
  const [showAppointmentForm, setShowAppointmentForm] = useState(false);
  const [selectedCounselor, setSelectedCounselor] = useState(null);
  const [notification, setNotification] = useState(null);
  const [isVideoActive, setIsVideoActive] = useState(false); // Mock data
  const workshops = [
    {
      id: 1,
      title: "Career Planning Workshop",
      date: "2024-03-15",
      location: "Room 101",
      registered: false,
    },
    {
      id: 2,
      title: "Resume Writing Workshop",
      date: "2024-03-20",
      location: "Room 102",
      registered: false,
    },
    {
      id: 3,
      title: "Interview Skills Workshop",
      date: "2024-03-25",
      location: "Room 103",
      registered: false,
    },
    {
      id: 4,
      title: "Networking Strategies",
      date: "2024-04-02",
      location: "Room 105",
      registered: false,
    },
  ];

  const counselors = [
    {
      id: 1,
      name: "Dr. Sarah Johnson",
      specialty: "Career Development",
      availability: "Mon-Fri, 9AM-5PM",
      image: "https://randomuser.me/api/portraits/women/1.jpg",
    },
    {
      id: 2,
      name: "Dr. Michael Chen",
      specialty: "Academic Planning",
      availability: "Mon-Thu, 10AM-6PM",
      image: "https://randomuser.me/api/portraits/men/1.jpg",
    },
  ];

  const appointments = [
    {
      id: 1,
      date: "2024-03-10",
      reason: "Career Planning Discussion",
      status: "accepted",
    },
    {
      id: 2,
      date: "2024-03-15",
      reason: "Resume Review",
      status: "pending",
    },
  ];

  // Mock data for reports
  // Removed unused reports array
  // Use the imported companies data instead of hardcoded data
  const suggestedCompanies = companiesData.slice(0, 3); // Get first 3 companies for the dashboard

  const handleScheduleAppointment = (counselor) => {
    setSelectedCounselor(counselor);
    setShowAppointmentForm(true);
  };

  const handleSubmitAppointment = (e) => {
    e.preventDefault();
    setShowAppointmentForm(false);
    setNotification({
      type: "success",
      message: "Appointment request submitted successfully!",
    });
    setTimeout(() => setNotification(null), 3000);
  };

  const handleVideoCall = () => {
    setIsVideoActive(!isVideoActive);
  };

  const renderView = () => {
    switch (activeView) {
      case "dashboard":
        return (
          <>
            <WelcomeSection>
              <WelcomeTitle>Welcome, Student!</WelcomeTitle>
              <WelcomeText>
                Your personalized dashboard is here to help you navigate your
                academic and career journey. Explore workshops, schedule
                appointments, and discover internship opportunities.
              </WelcomeText>
            </WelcomeSection>
            <DashboardGrid>
              {" "}
              <GridColumn>
                {" "}
                <DashboardCard
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {" "}
                  <h3>Upcoming Workshops</h3>
                  <WorkshopsList
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.8rem",
                        flex: 1,
                      }}
                    >
                      {workshops.map((workshop) => (
                        <WorkshopItem
                          key={workshop.id}
                          style={{
                            padding: "0.75rem",
                            margin: 0,
                            position: "relative",
                          }}
                        >
                          <WorkshopDate style={{ marginBottom: "0.3rem" }}>
                            {workshop.date}
                          </WorkshopDate>
                          <WorkshopTitle
                            style={{
                              fontSize: "0.95rem",
                              margin: "0 0 0.4rem 0",
                            }}
                          >
                            {workshop.title}
                          </WorkshopTitle>
                          <WorkshopLocation style={{ fontSize: "0.8rem" }}>
                            {workshop.location}
                          </WorkshopLocation>
                          {workshop.id === 1 && (
                            <StatusBadge status="live">Live</StatusBadge>
                          )}
                          {workshop.id === 2 && (
                            <StatusBadge status="upcoming">
                              Upcoming
                            </StatusBadge>
                          )}
                          {workshop.id === 3 && (
                            <StatusBadge status="pre-recorded">
                              Pre-recorded
                            </StatusBadge>
                          )}
                          {workshop.id === 4 && (
                            <StatusBadge status="completed">
                              Completed
                            </StatusBadge>
                          )}
                        </WorkshopItem>
                      ))}
                    </div>{" "}
                    <ViewAllButton
                      onClick={() => setActiveView("workshops")}
                      style={{ marginTop: "1rem" }}
                    >
                      View All Workshops
                    </ViewAllButton>
                  </WorkshopsList>
                </DashboardCard>
                <ProfileViews style={{ marginTop: "2rem", height: "auto" }} />
              </GridColumn>{" "}
              <GridColumn>
                {" "}
                <DashboardCard>
                  <h3>Suggested Companies</h3>
                  <SuggestedCompaniesSection>
                    {suggestedCompanies.map((company) => (
                      <CompanyCard key={company.id}>
                        <CompanyLogo src={company.logo} alt={company.name} />
                        <CompanyInfo>
                          <CompanyName>{company.name}</CompanyName>{" "}
                          <CompanyDescription>
                            {company.description}
                          </CompanyDescription>
                          <CompanyTags>
                            {company.interests.map((interest) => (
                              <CompanyTag key={interest}>{interest}</CompanyTag>
                            ))}
                          </CompanyTags>
                          <ApplyButton
                            onClick={() => setActiveView("internships")}
                          >
                            Apply Now
                          </ApplyButton>
                        </CompanyInfo>
                      </CompanyCard>
                    ))}
                  </SuggestedCompaniesSection>
                </DashboardCard>
              </GridColumn>
            </DashboardGrid>
            <SectionDivider />{" "}
            <DashboardGrid>
              <GridColumn>
                <DashboardCard>
                  <h3>Internship Guidelines</h3>
                  <InternshipGuidelinesVideo
                    defaultMajor="Computer Science"
                    studentType="pro"
                  />
                </DashboardCard>
              </GridColumn>
            </DashboardGrid>
            {showAppointmentForm && selectedCounselor && (
              <AppointmentRequestForm isVisible={showAppointmentForm}>
                <h4>Schedule Appointment with {selectedCounselor.name}</h4>
                <form onSubmit={handleSubmitAppointment}>
                  <FormInputGroup>
                    <label>Date</label>
                    <input type="date" required />
                  </FormInputGroup>
                  <FormInputGroup>
                    <label>Time</label>
                    <input type="time" required />
                  </FormInputGroup>
                  <FormInputGroup>
                    <label>Reason</label>
                    <input
                      type="text"
                      placeholder="Brief description of your appointment reason"
                      required
                    />
                  </FormInputGroup>
                  <FormButtons>
                    <ScheduleButton type="submit">
                      Submit Request
                    </ScheduleButton>
                    <ScheduleButton
                      type="button"
                      onClick={() => setShowAppointmentForm(false)}
                    >
                      Cancel
                    </ScheduleButton>
                  </FormButtons>
                </form>
              </AppointmentRequestForm>
            )}
          </>
        );
      case "profile":
        return <StudentProfile isProStudent={true} />;
      case "majors":
        return <MajorsList />;
      case "assessments":
        return <AssessmentCenter />;
      case "workshops":
        return <WorkshopHub />;
      case "internships":
        return <Internships />;
      case "applications":
        return <ApplicationsList />;
      case "reports":
        return <ReportManagement />;
      case "video":
        return (
          <VideoContainer>
            <VideoCallSystemDemo />
          </VideoContainer>
        );
      default:
        return null;
    }
  };

  return (
    <DashboardContainer>
      <SpaceBackground />
      <PageHeader>
        <PageTitle>
          <NavLogo>
            <FaUserGraduate />
            ProStudent Dashboard
          </NavLogo>
        </PageTitle>
      </PageHeader>

      <NavContainer>
        {/* Dynamic neon glow effects */}
        <div className="neon-orb"></div>
        <div className="neon-spot-1"></div>
        <div className="neon-spot-2"></div>
        <div className="neon-spot-3"></div>

        <NavRow>
          <NavButton
            active={activeView === "dashboard"}
            onClick={() => setActiveView("dashboard")}
          >
            <FaHome /> Dashboard
          </NavButton>
          <NavButton
            active={activeView === "profile"}
            onClick={() => setActiveView("profile")}
          >
            <FaUserGraduate /> Profile
          </NavButton>
          <NavButton
            active={activeView === "majors"}
            onClick={() => setActiveView("majors")}
          >
            <FaGraduationCap /> Majors
          </NavButton>
          <NavButton
            active={activeView === "assessments"}
            onClick={() => setActiveView("assessments")}
          >
            <FaChartBar /> Assessments
          </NavButton>
        </NavRow>

        <NavRow>
          <NavButton
            active={activeView === "workshops"}
            onClick={() => setActiveView("workshops")}
          >
            <FaChalkboardTeacher /> Workshops
          </NavButton>
          <NavButton
            active={activeView === "applications"}
            onClick={() => setActiveView("applications")}
          >
            <FaClipboardList /> Applications
          </NavButton>
          <NavButton
            active={activeView === "reports"}
            onClick={() => setActiveView("reports")}
          >
            <FaFileAlt /> Reports & Evaluations
          </NavButton>
          <NavButton
            active={activeView === "video"}
            onClick={() => setActiveView("video")}
          >
            <FaVideo /> Appointments
          </NavButton>
        </NavRow>
      </NavContainer>

      {notification && (
        <NotificationBar type={notification.type}>
          {notification.message}
        </NotificationBar>
      )}
      {renderView()}
    </DashboardContainer>
  );
};

export default ProStudentDashboard;
